export const einvNotes = `
# \n\n
### Steps to Enable e-Invoicing in GST Einvoice Portal:
 
1. Go to the GST Einvoice Portal ( Not to gst.gov.in )\n
   Open [einvoice1.gst.gov.in](https://einvoice1.gst.gov.in) in your browser.
 
2. Open the Registration Menu\n
   From the top menu, click Registration → select e-Invoice Enablement.
 
3. Verify with OTP\n
   Enter your GSTIN, mobile number, and click Send OTP. Enter the OTP to verify.
 
4. Register API User through GSP\n
   After enablement, go to the API Registration menu → choose Through GSP.
 
5. Select Alankit as GSP\n
   From the GSP list, pick Alankit Limited.
 
6. Create API User ID and Password\n
   Enter a new User ID and Password for e-Invoicing (these are different from your GST portal login). Click Submit.
----
 
### Configure in LedgerX
 
7. In LedgerX → Company Setup → e-Invoice Enable, choose Alankit (GSP).
 
8. Enter the User ID and Password you created above.
 
9. Click Save & Connect Permanently if you want LedgerX to remember your credentials, or you can enter them at the time of generating each Sales Invoice.
----
### Generate e-Invoice

10. Now, when you create a Sales Invoice in LedgerX, click Generate IRN to get your e-Invoice with IRN & QR Code instantly.
`;
